import { Box, SimpleGrid, Stack, Text, Title, Anchor, Group } from "@mantine/core";
import { pressQuotes, pressMentions } from "@/content/press";
import { PressQuote } from "@/components/press/PressQuote";
import { EmptyState } from "@/components/common/EmptyState";
import { PageHero } from "@/components/layout/PageHero";
import { PageContainer } from "@/components/layout/PageContainer";

export default function Press() {
  const hasAnyContent = pressQuotes.length > 0 || pressMentions.length > 0;

  return (
    <>
      <PageHero title="Press" subtitle="Quotes, mentions, and downloadable assets." />
      <PageContainer navOffset={false}>
        <Stack gap="xl">
          <Group gap="md">
            <Anchor href="/press/onesheet.pdf" target="_blank">
              One-sheet (PDF)
            </Anchor>
            <Anchor href="/press/press-kit.zip">Full press kit (zip)</Anchor>
            <Anchor href="/logos/7md-mark.svg" download>
              Logo pack
            </Anchor>
          </Group>

          {!hasAnyContent && (
            <EmptyState
              title="Press accumulating"
              body="Quotes, premieres, and mentions land here as coverage rolls out. (if you make an article or post, do tell me lol)"
            />
          )}

          {pressQuotes.length > 0 && (
            <Box>
              <Title order={2} size="h3" mb="sm">
                Quotes
              </Title>
              <SimpleGrid cols={{ base: 1, md: 2 }} spacing="md">
                {pressQuotes.map((q, i) => (
                  <PressQuote key={i} quote={q} />
                ))}
              </SimpleGrid>
            </Box>
          )}

          {pressMentions.length > 0 && (
            <Box>
              <Title order={2} size="h3" mb="sm">
                Mentions
              </Title>
              <Stack gap="xs">
                {pressMentions.map((m) => (
                  <Anchor key={m.url} href={m.url} target="_blank" rel="noopener noreferrer">
                    <Text size="sm">
                      <Text component="span" tt="uppercase" c="dimmed">
                        {m.outlet}
                      </Text>{" "}
                      — {m.title}
                    </Text>
                  </Anchor>
                ))}
              </Stack>
            </Box>
          )}
        </Stack>
      </PageContainer>
    </>
  );
}
